import React from "react";
import { Button, Popover, Table, Typography } from "antd";
import { InfoCircleOutlined } from "@ant-design/icons";

const { Paragraph } = Typography;

/** The reasons the cleaning step can give for leaving an airing out of the model (lib/episode_scoring/clean.py). */
export const EXCLUSION_REASONS: { reason: string; meaning: string }[] = [
  {
    reason: "noise platform",
    meaning: "The platform's median minutes per airing is under 60, too small to carry any signal (for example HP, Kogan, WISPTV, WhaleTV, Xiaomi).",
  },
  {
    reason: "near-zero viewership",
    meaning: "The airing earned under 5% of the platform's median rate on an otherwise normal day: a reporting gap, not audience behaviour.",
  },
  {
    reason: "no ref id",
    meaning: "Amagi's content id has no ref id prefix (mostly Escandalos). The airing still shapes the slot baselines but cannot be scored as an episode.",
  },
  {
    reason: "platform day outage",
    meaning: "The platform's total for that day is under 10% of its median day: an onboarding ramp (Vizio before mid June) or a feed collapse.",
  },
  { reason: "no viewership", meaning: "Zero or missing minutes watched." },
  { reason: "no series", meaning: "No series name on the row, or a promo rather than an episode." },
  { reason: "short or missing duration", meaning: "A playout under five minutes, usually a fragment, or no duration at all." },
];

/** A link that opens the table of exclusion reasons. */
const ExclusionReasons: React.FC<{ text?: string }> = ({ text = "Why an airing can be excluded" }) => (
  <Popover
    trigger="click"
    placement="bottomLeft"
    overlayStyle={{ maxWidth: 720 }}
    title="Why the cleaning step leaves an airing out"
    content={
      <>
        <Paragraph type="secondary" style={{ marginBottom: 8 }}>
          Every raw row gets at most one reason; the first rule that matches wins. Excluded rows stay in the raw table
          and are counted on the job (Jobs tab, clean step) but do not feed the baselines or the scores.
        </Paragraph>
        <Table
          size="small"
          rowKey="reason"
          pagination={false}
          dataSource={EXCLUSION_REASONS}
          columns={[
            { title: "Reason", dataIndex: "reason", width: 190 },
            { title: "Meaning", dataIndex: "meaning" },
          ]}
        />
      </>
    }
  >
    <Button
      type="link"
      size="small"
      icon={<InfoCircleOutlined />}
      style={{ padding: 0, height: "auto", verticalAlign: "baseline", fontSize: "inherit" }}
    >
      {text}
    </Button>
  </Popover>
);

export default ExclusionReasons;
